import { __decorate, __metadata } from "tslib";
import { Expose } from '../class-transformer';
import { Default } from '../model-decorators';
import { Model } from './model.class';
export class ItemModel extends Model {}
;
export let IdItemModel = /*#__PURE__*/(() => {
  class IdItemModel extends ItemModel {}
  __decorate([Expose(), Default(undefined), __metadata("design:type", Number)], IdItemModel.prototype, "id", void 0);
  return IdItemModel;
})();
;